import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import {useParams } from "react-router";
import { useStore } from "../../../app/stores/store";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { Button, Icon } from 'semantic-ui-react'
import '../Diplomas/MisDiplomas.css'
import axios from "axios";

const apiURL = process.env.REACT_APP_API_URL;

export default observer(function MisDiplomas() {     
    var pathGUID = window.location.pathname.split('/')[5];
    
    const url = `${apiURL}/Docs/DegreesByUser/${pathGUID}`
    const [degrees, setDegrees] = useState([]);    

    const listaRecibos = async () => {
        const responseRecibo = await axios(url);
        const { data } = responseRecibo;        
        
        return data;
    }
    
    useEffect(() => { 
        let isMounted = true;
        
        listaRecibos().then((recibos) => { 
            if(isMounted){                
                setDegrees(recibos);
            }
        })
        
        return () => {
            isMounted = false;
        }
    }, []);

    return (
        <>
            <h1 className="diplomas-title">Mis Diplomas</h1>
            <p style={{textAlign: "center"}}>Estimado participante, el Instituto Nacional de Administración Pública - INAP, pone a tu disposición el Portal de Emisión de Diplomas y Certificaciones, como una herramienta de autogestión para la observación de tus certificados de servicios academicos aprobados.</p>
            <div className="table-responsive">
                <table>
                    <thead>
                        <tr className="diploma-head-row">
                            <th className="diploma-head-th">Código Diploma</th>    
                            <th className="diploma-head-th">Servicio Academico</th>
                            <th className="diploma-head-th">Descargar</th>
                        </tr>
                    </thead>
                    <tbody>                        
                        {degrees.map((degree: {id: number; dip_registro: string; nameCur: string; link_archivo: string;}) => {
                            return(
                                <tr key={degree.id} className="diploma-body-row">
                                    <td>
                                        {degree.dip_registro}
                                    </td>
                                    <td>
                                        {degree.nameCur}
                                    </td>
                                    <td>
                                        <a href={degree.link_archivo} target="_blank">
                                        <Button animated='vertical' color='green' className="desc">
                                                    <Button.Content hidden>Descargar</Button.Content>
                                                    <Button.Content visible><Icon name='file pdf' /></Button.Content>
                                            </Button>
                                        </a>
                                    </td>
                                </tr>
                            )                            
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
})